/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class GuaranteedRestoreTimePolicyService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        this.$log.debug('Service \'GuaranteedRestoreTimePolicyService\' loaded');
    }

    /**
     * Updates multiple policies at once.
     *
     * @param {Object[]} entities Entities.
     * @returns {Promise} A promise providing the result.
     */
    updateEntities(entities) {
        return this.resource.updateEntities(undefined, entities).$promise;
    }
}

export { GuaranteedRestoreTimePolicyService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/GuaranteedRestoreTimePolicyService.js